import { logger } from "./logger";

/**
 * Install global error handlers for uncaught exceptions and
 * unhandled promise rejections.
 *
 * Call this once at application startup (e.g., in main.tsx).
 */
export function installGlobalErrorHandlers(): void {
  window.addEventListener("error", (event: ErrorEvent) => {
    logger.error("Uncaught error", {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const { reason } = event;
    if (reason instanceof Error) {
      logger.error("Unhandled promise rejection", {
        message: reason.message,
        stack: reason.stack,
      });
    } else {
      logger.error("Unhandled promise rejection", {
        reason: reason,
      });
    }
  });
}
